import { useArticleContext } from './useArticleContext';

export const useArticleCategories = () => {
  const [state] = useArticleContext();
  return state.initial ? [] : state.categories;
};
